import { render, staticRenderFns } from "./GCooling.vue?vue&type=template&id=019f4646&scoped=true"
import script from "./GCooling.vue?vue&type=script&lang=ts"
export * from "./GCooling.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019f4646",
  null
  
)

export default component.exports